import { useState } from "react";
import { copyToClipboard } from "../utils";
import { SYMBOL_MAP } from "../constants";

const TileCrypto = ({ data = {}, t }) => {
  const [copied, setCopied] = useState(false);
  const str = (v) => (typeof v === "string" ? v.trim() : "");
  const coin = str(data.coin);
  const title = str(data.title);
  const address = str(data.address);
  const assetType = str(data.asset_type);
  const standard = str(data.standard);

  if (!coin && !title && !address) return null;

  const resolvedSymbol = SYMBOL_MAP[coin] || coin.toLowerCase() || "btc";

  const handleCopy = async (e) => {
    e.stopPropagation();
    await copyToClipboard(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* Top row: icon + coin name + tags */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: t.labelBg,
              border: `1px solid ${t.labelBorder}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.04em",
              color: t.textSecondary,
              fontFamily: "monospace",
            }}
          >
            {resolvedSymbol.slice(0, 4).toUpperCase()}
          </div>

          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            {coin && (
              <span
                style={{ fontSize: 15, fontWeight: 600, color: t.textPrimary }}
              >
                {coin}
              </span>
            )}
            {title && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.badgeBg,
                  border: `1px solid ${t.badgeBorder}`,
                  color: t.badgeText,
                }}
              >
                {title}
              </span>
            )}
            {assetType && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                  textTransform: "capitalize",
                }}
              >
                {assetType}
              </span>
            )}
            {standard && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {standard}
              </span>
            )}
          </div>
        </div>

        {/* Address row */}
        {address && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            <button
              onClick={handleCopy}
              type="button"
              aria-label="Copy address"
              style={{
                flexShrink: 0,
                padding: 6,
                borderRadius: 8,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                color: copied ? t.successText : t.textMuted,
                transition: "color 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = t.pillHoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {copied ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              ) : (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" />
                  <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                </svg>
              )}
            </button>
            <p
              style={{
                fontSize: 11,
                color: t.textMuted,
                margin: 0,
                fontFamily: "monospace",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
              title={address}
            >
              {address}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TileCrypto;
